import React, { useState } from 'react';
type GalleryItem = {
  src: string;
  alt: string;
  label: string;
  tag?: string;
};
const photos: GalleryItem[] = [{
  src: 'https://cdn.magicpatterns.com/uploads/jXC3M7BSBQyxv8PD3X1ekY/Screenshot_2026-07-10_104327.png',
  alt: 'Arizona desert pool with rock landscaping',
  label: 'Desert Pool — AZ',
  tag: 'Pool Service'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/41rnj77y6oBHYW2mGYjfha/Screenshot_2026-07-10_104206.png',
  alt: 'Modern pool and spa with tile work',
  label: 'Modern Pool & Spa',
  tag: 'Tile Cleans'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/7TqMDe6nDkEdyekPmqcvwb/Screenshot_2026-07-10_105112.png',
  alt: 'Crystal-clear backyard pool in Arizona',
  label: 'Crystal-Clear Pool',
  tag: 'Pool Service'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/onBztB8wvnWtoNFRdCEbZ9/Screenshot_2026-07-10_105037.png',
  alt: 'Bright blue pool with rock water feature',
  label: 'Backyard Oasis',
  tag: 'Water Features'
}];
export function Gallery() {
  const [active, setActive] = useState<GalleryItem | null>(null);
  return <section id="gallery" className="w-full bg-[#0a0e16] pt-12 pb-12 sm:py-20 px-4 sm:px-6" data-id="element-68">
      <div className="max-w-6xl mx-auto" data-id="element-69">
        {/* Header */}
        <div className="text-center mb-14" data-id="element-70">
          <span className="text-[#2979ff] text-sm font-bold tracking-widest uppercase" data-id="element-71">
            Our Work
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-white mt-2 mb-4" data-id="element-72">
            Results That Speak for Themselves
          </h2>
          <p className="text-gray-400 max-w-xl mx-auto text-base sm:text-lg" data-id="element-73">
            Real jobs, real results. See what Elite Poolz delivers for Arizona
            homeowners.
          </p>
        </div>

        {/* Photo grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-74">
          {photos.map(photo => <button key={photo.src} className="relative group rounded-2xl overflow-hidden focus:outline-none focus:ring-2 focus:ring-[#2979ff]" onClick={() => setActive(photo)} aria-label={`View ${photo.label}`} data-id="element-75">
              <img src={photo.src} alt={photo.alt} className="w-full h-64 sm:h-72 object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-76" />
              <div className="absolute inset-0 bg-[#0d1117]/40 group-hover:bg-[#0d1117]/20 transition-colors" data-id="element-77" />
              <div className="absolute bottom-0 left-0 right-0 p-4 flex items-end justify-between" data-id="element-78">
                <span className="text-white font-bold text-lg drop-shadow" data-id="element-79">
                  {photo.label}
                </span>
                <span className="bg-[#2979ff] text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-80">
                  {photo.tag}
                </span>
              </div>
            </button>)}
        </div>
      </div>

      {/* Lightbox */}
      {active && <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4" onClick={() => setActive(null)} role="dialog" aria-modal="true" aria-label={active.alt} data-id="element-81">
          <div className="relative max-w-3xl w-full" onClick={e => e.stopPropagation()} data-id="element-82">
            <img src={active.src} alt={active.alt} className="w-full rounded-2xl max-h-[80vh] object-contain" data-id="element-83" />
            <div className="mt-3 flex flex-col items-center gap-2 text-center sm:flex-row sm:justify-between sm:text-left" data-id="element-84">
              <span className="text-white font-bold" data-id="element-85">{active.label}</span>
              <button onClick={() => setActive(null)} className="text-gray-400 hover:text-white text-sm font-medium" data-id="element-86">
                Close ✕
              </button>
            </div>
          </div>
        </div>}
    </section>;
}